﻿import {UIText} from "../Tools/Base/UIText";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {Core} from "../../Base/Core";
import {Time} from "../../Utils/Unity/Time";
import {NUtils} from "../../Utils/NUtils";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {MissionRewards} from "../Tools/Mission/MissionRewards";
import {UISprite} from "../Tools/Base/UISprite";
import {RewardedAdsBtn} from "../RewardedAdsBtn";

export class UIMissionActive extends UICommonPopup {
    Awake() {
        super.Awake({
            title: Core.Localizator.Get("missions"),
            closeButton: true,
        });

        this.iconImage = this.content.addChild(new UISprite("rocket"));

        this.missionItemBack = this.content.addChild(new UINineSlice("bg-simple"));
        this.missionItemBack.tint = 0x000000;
        this.missionItemBack.alpha = 0.3;

        this.rocket = this.content.addChild(new UISprite("rocket-noflame"));

        this.nameField = this.content.addChild(new UIText());

        this.timeField = this.content.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-clock",
                iconAlign: "absolute-left",
                iconSize: 1.2,
                textProps: {
                    // fitTextTemplate: "00h 00m 00s",
                },
            })
        );
        this.timeField._label.anchor.set(0, 0.5);

        this.adsBtn = this.content.addChild(
            new RewardedAdsBtn("btn-green", {
                label: Core.Localizator.Get("ads"),
                icon: "play-icon",
                iconAlign: "right",
            })
        );

        this.rewards = this.content.addChild(new MissionRewards());

        this.collectBtn = this.content.addChild(new UINineSliceButton("btn-green", Core.Localizator.Get("collect")));

        this.lastTimerUpdate = 0;
    }

    Init() {
        super.Init();
        this.updateRewards();
        this.collectBtn.on("pointertap", () => {
            let isInProgress = Core.Player.Missions.IsInProgress();
            if (!isInProgress) {
                this.Hide();
                let activeMission = Core.Player.Missions.missionInProgress;
                let missionData = Core.GameData.Missions.GetMission(activeMission.missionId);
                Core.UI.missionRewards.Show(missionData.id, missionData.rewards);
                Core.UI.map.missionsBtn.inactiveMissionAttention()
            }
        });

        this.adsBtn.on("pointertap", () => {
            Core.Ads.TriggerRewarded(
                () => {
                    Core.Player.Missions.MinusTime(1800);
                    this.updateUI();
                    this.updateTimer();
                }
            );
        });
    }

    Show() {
        this.updateUI();
        this.updateRewards();
        this.updateTimer();
        super.Show();
    }

    Update() {
        this.lastTimerUpdate += Time.deltaTime;
        if (this.lastTimerUpdate > 1) {
            this.updateTimer();
        }
        if (Core.Player.Initialized && Core.Player.Missions) {
            let isInProgress = Core.Player.Missions.IsInProgress();
            this.adsBtn.SetActive(isInProgress);
        }
    }

    updateTimer() {
        this.lastTimerUpdate = 0;
        let activeMission = Core.Player.Missions.missionInProgress;
        if (!activeMission) return;

        let timer = Core.Player.Timers.GetTimerById(activeMission.timerId);
        let secondsLeft = timer ? timer.SecondsLeft : 0;
        if (secondsLeft <= 0) {
            this.updateUI();
        } else {
            this.timeField.text = NUtils.FormatSecondsToTime(secondsLeft);
        }
    }

    updateRewards() {
        let activeMission = Core.Player.Missions.missionInProgress;
        if (activeMission) {
            let missionData = Core.GameData.Missions.GetMission(activeMission.missionId);
            this.rewards.Init(missionData.rewards);
        }
    }

    updateUI() {
        let activeMission = Core.Player.Missions.missionInProgress;
        let missionData = Core.GameData.Missions.GetMission(activeMission.missionId);
        let isInProgress = Core.Player.Missions.IsInProgress();

        this.collectBtn.interactive = !isInProgress;
        this.collectBtn.setImage(isInProgress ? "btn-gray" : "btn-green");
        this.adsBtn.interactive = true;
        this.adsBtn.SetActive(isInProgress);
        this.nameField.text = Core.Localizator.Get(missionData.missionName);
        this.timeField.SetActive(isInProgress);

        this.rewards.UpdateUI();
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.5;
        let w = Math.min(viewport.width * 0.9, (viewport.height * 0.8) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.width = contentRect.width * 0.7;
        rect.height = contentRect.height * 0.4;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.27;
        this.iconImage.fitRect(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.9;
        rect.height = contentRect.height * 0.4;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.95;
        this.missionItemBack.fitLayout(rect);

        let parentRect = new PIXI.Rectangle(
            this.missionItemBack.x,
            this.missionItemBack.y,
            this.missionItemBack.width,
            this.missionItemBack.height
        );

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.22;
        rect.height = parentRect.height * 0.35;
        rect.x = parentRect.x + parentRect.width * 0.02;
        rect.y = parentRect.y + parentRect.height * 0.07;
        this.rocket.fitRect(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.46;
        rect.height = parentRect.height * 0.13;
        rect.x = parentRect.x + parentRect.width * 0.24;
        rect.y = parentRect.y + parentRect.height * 0.1;
        this.nameField.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.4;
        rect.height = parentRect.height * 0.1;
        rect.x = parentRect.x + parentRect.width * 0.24;
        rect.y = parentRect.y + parentRect.height * 0.27;
        this.timeField.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.24;
        rect.height = parentRect.height * 0.25;
        rect.x = parentRect.x + parentRect.width * 0.73;
        rect.y = parentRect.y + parentRect.height * 0.1;
        this.adsBtn.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.95;
        rect.height = parentRect.height * 0.17;
        rect.x = parentRect.x + parentRect.width * 0.02;
        rect.y = parentRect.y + parentRect.height * 0.46;
        this.rewards.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.47;
        rect.height = parentRect.height * 0.23;
        rect.x = parentRect.x + (parentRect.width - rect.width) * 0.5;
        rect.y = parentRect.y + (parentRect.height - rect.height) * 0.92;
        this.collectBtn.fitLayout(rect);
    }
}
